import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'

class CannotReviewModal extends Component {

  render () {
    return (
      <div>
        <Modal
          style={{top: '120px'}}
          show={this.props.show}
          onHide={this._close}
          container={this}
          aria-labelledby='contained-modal-title'
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: '14px', fontWeight: '400', color: 'rgba(255, 255, 255, 0.83)' }}>Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Cannot review, please complete all the required fields with correct value.
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn btn-primary' onClick={this._close}>OK</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  _close = (e) => {
    e.stopPropagation()
    this.props.close()
  }
}

export default CannotReviewModal



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/Program/CannotReviewModal.js